import React, { useEffect, useState } from 'react';
import SubscriptionApi from '../api/SubscriptionApi';
import SubscriptionItem from './SubscriptionItem';

const MySubscription = ({ user }) => {
  const [allSubscriptions, setAllSubscriptions] = useState([]);

  const userId = user?.ID;

  const fetchUserSubscriptions = async (userId) => {
    const subscriptions = await SubscriptionApi.get(userId);
    setAllSubscriptions(subscriptions);
  };

  useEffect(() => {
    fetchUserSubscriptions(userId);
  }, [userId]);

  return (
    <div className="relative overflow-x-auto">
      <div className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <div>
        {
          allSubscriptions?.length > 0 ? (
            allSubscriptions.map((subscription) => (
              <SubscriptionItem key={subscription.id} subscription={subscription} />
            ))
          ) : (
            <div className="text-start py-4  text-yellow-700 rounded-md">
              No subscriptions found. Please check back later or contact support.
            </div>
          )
        }
        </div>
      </div>
    </div>
  );
};

export default MySubscription;